import React from 'react';
import '../styles/beneficios-diferencias.css';

const beneficios = [
  { icon: '⚡', title: 'Mezcla perfecta', text: 'Sin grumos en ~15 segundos con motor turbo recargable.' },
  { icon: '🧽', title: 'Fácil de lavar', text: 'Auto-clean: agua + 1 gota de jabón, 10–15 segundos.' },
  { icon: '🔋', title: 'Recargable USB-C', text: 'Carga rápida y batería duradera para varios usos al día.' },
  { icon: '🧴', title: 'Seguro y duradero', text: 'BPA-free y diseño robusto para uso diario.' },
];

const diferencias = [
  { f: 'Sin grumos (≈15 s)', a: '✓', b: '❌' },
  { f: 'Carga USB-C', a: '✓', b: '❌' },
  { f: 'Capacidad 650 ml con marcas', a: '✓', b: '⚠️ Variable' },
  { f: 'BPA-free / Apto alimentos', a: '✓', b: 'Depende del plástico' },
  { f: 'Limpieza rápida (10–15 s)', a: '✓', b: '❌ Manual intensiva' },
];

const BeneficiosDiferencias: React.FC = () => {
  return (
    <div className="bd-wrapper">
      {/* ===== Beneficios ===== */}
      <section className="redes-sociales-wrapper">
        <h2 className="titulo-redes">Beneficios</h2>
        <div className="wide-inner">
          <div className="beneficios-grid">
            {beneficios.map((b) => (
              <article key={b.title} className="beneficio-card" aria-label={b.title}>
                <div className="beneficio-icon" aria-hidden="true">
                  <span>{b.icon}</span>
                </div>
                <h3 className="beneficio-title">{b.title}</h3>
                <p className="beneficio-text">{b.text}</p>
              </article>
            ))}
          </div>

          <div className="tip">
            💧 <strong>Tip:</strong> agrega agua y una gota de lava-lozas, presiona 10–15 s.
          </div>
        </div>
      </section>

      {/* ===== Diferencias ===== */}
      <section className="redes-sociales-wrapper">
        <h2 className="titulo-redes">Diferencias</h2>
        <div className="wide-inner">
          <div className="cmp-grid" role="table" aria-label="Comparativa Shaker Premium vs manual">
            <div className="cmp-head" role="row">
              <div className="cmp-col feature" role="columnheader">Característica</div>
              <div className="cmp-col ours" role="columnheader">Shaker Premium</div>
              <div className="cmp-col other" role="columnheader">Shaker manual</div>
            </div>

            {diferencias.map((row) => (
              <div className="cmp-row" role="row" key={row.f}>
                <div className="cmp-cell feature" role="cell" data-label="Característica">{row.f}</div>
                {/* Agregamos una clase específica para el check verde */}
                <div className="cmp-cell ours check-verde" role="cell" data-label="Shaker Premium">{row.a}</div>
                <div className="cmp-cell other" role="cell" data-label="Shaker manual">{row.b}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BeneficiosDiferencias;